import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import NoDataFound from '../../../../components/NodataIndication/NoDataFound';
import { WD } from '../../../warningDashboard/warningTheme';
import { CARD_BG } from '../utils/constants';
import Panel from './Panel';
import PanelTitle from './PanelTitle';
import LevelFilterChips from './LevelFilterChips';
import PersonRow from './PersonRow';
import PersonCard from './PersonCard';

/**
 * "Allocation by person" - hours against capacity, heaviest first, with a filter by load level. A table from `md` up; below it
 * every person becomes a stacked card.
 */
export default function PersonTable({ summary, levelFilter, onLevelFilter, onOpen }) {
  const rows = levelFilter === 'all' ? summary.rows : summary.rows.filter((row) => row.level === levelFilter);

  return (
    <Panel sx={{ overflow: 'hidden' }}>
      <Box sx={{ p: 2.5, pb: 2 }}>
        <PanelTitle
          title="Allocation by person"
          hint="Sorted by highest load · click a person for details"
          right={<LevelFilterChips summary={summary} value={levelFilter} onChange={onLevelFilter} />}
        />
      </Box>

      {/* Table, md and up */}
      <TableContainer sx={{ display: { xs: 'none', md: 'block' }, border: 'none', borderRadius: 0, borderTop: `1px solid ${WD.border}`, maxHeight: 'none', bgcolor: CARD_BG }}>
        <Table size="small" sx={{ tableLayout: 'fixed' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '30%', pl: 2.5 }}>MEMBER</TableCell>
              <TableCell align="right" sx={{ width: '9%' }}>TASKS</TableCell>
              <TableCell sx={{ width: '15%' }}>ALLOCATED</TableCell>
              <TableCell align="right" sx={{ width: '9%' }}>LOGGED</TableCell>
              <TableCell>LOAD VS CAPACITY ( | = 100% )</TableCell>
              <TableCell sx={{ width: '14%' }}>STATUS</TableCell>
              <TableCell sx={{ width: 40 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <PersonRow key={row.person.id} row={row} onOpen={onOpen} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Cards, below md */}
      <Box component="ul" sx={{ display: { xs: 'block', md: 'none' }, listStyle: 'none', m: 0, p: 0, borderTop: `1px solid ${WD.border}` }}>
        {rows.map((row) => (
          <PersonCard key={row.person.id} row={row} onOpen={onOpen} />
        ))}
      </Box>

      {!rows.length && <NoDataFound message="Nobody matches this filter." />}
    </Panel>
  );
}
